<template>
  <a
    :class="hover ? 'link link--hover' : 'link'"
    :href="href"
    :style="style"
    @click.prevent="$emit('click')"
  >
    <slot>{{ href }}</slot>
  </a>
</template>
<script>
export default {
  name: 'UstyledLink',

  props: {
    href: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'inherit'
    },
    textDecoration: {
      type: String,
      default: 'none'
    },
    hover: { // enable text-decoration: underline on hover
      type: Boolean,
      default: false
    },
    fillParent: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    style () {
      return {
        display: this.fillParent ? 'flex' : null,
        alignItems: this.fillParent ? 'center' : null,
        height: this.fillParent ? '100%' : null,
        color: this.color,
        'textDecoration': this.textDecoration
      }
    }
  }
}
</script>
<style scoped>
  .link--hover:hover {
    text-decoration: underline !important;
  }
</style>
